module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"form":{"errors":{"maxValue":"Cannot exceed {0}","minValue":"Must be at least {0}"}}}}')
  delete Component.options._Ctor
}
